import { NoteStyled, NoteLabelStyled } from './Note.styled';
import Note from './Note';

export { NoteStyled, NoteLabelStyled };

export default Note;
